import type { Option } from '@/constants/institute';
import type {
  SalaryCalculation,
  SalaryComponentKind,
  SalaryRevisionType,
} from '@/types/payroll';

/** One source for every payroll label, so the list, the form and the profile agree. */

export const SALARY_KIND_LABEL: Record<SalaryComponentKind, string> = {
  EARNING: 'Earning',
  DEDUCTION: 'Deduction',
};

export const SALARY_CALCULATION_LABEL: Record<SalaryCalculation, string> = {
  FIXED: 'Fixed amount',
  PERCENT_OF_BASIC: '% of Basic',
};

export const SALARY_REVISION_LABEL: Record<SalaryRevisionType, string> = {
  JOINING: 'Joining salary',
  INCREMENT: 'Increment',
  PROMOTION: 'Promotion',
  CORRECTION: 'Correction',
};

export const SALARY_KIND_OPTIONS: Option<SalaryComponentKind>[] = [
  { value: 'EARNING', label: SALARY_KIND_LABEL.EARNING },
  { value: 'DEDUCTION', label: SALARY_KIND_LABEL.DEDUCTION },
];

export const SALARY_CALCULATION_OPTIONS: Option<SalaryCalculation>[] = [
  { value: 'FIXED', label: SALARY_CALCULATION_LABEL.FIXED },
  { value: 'PERCENT_OF_BASIC', label: SALARY_CALCULATION_LABEL.PERCENT_OF_BASIC },
];

/**
 * The reasons a salary can be set for. A first salary is always the joining
 * one, and a later one never is — the server refuses either mix-up, and the
 * form only offers what fits.
 */
export const FIRST_SALARY_OPTIONS: Option<SalaryRevisionType>[] = [
  { value: 'JOINING', label: SALARY_REVISION_LABEL.JOINING },
];

export const LATER_SALARY_OPTIONS: Option<SalaryRevisionType>[] = [
  { value: 'INCREMENT', label: SALARY_REVISION_LABEL.INCREMENT },
  { value: 'PROMOTION', label: SALARY_REVISION_LABEL.PROMOTION },
  { value: 'CORRECTION', label: SALARY_REVISION_LABEL.CORRECTION },
];
